import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "delete-confirmation__content" }
const _hoisted_2 = { class: "delete-confirmation__warning" }
const _hoisted_3 = { class: "delete-confirmation__warning-text" }
const _hoisted_4 = { class: "delete-confirmation__details" }
const _hoisted_5 = { class: "delete-confirmation__detail-item" }
const _hoisted_6 = { class: "delete-confirmation__detail-label" }
const _hoisted_7 = { class: "delete-confirmation__detail-value" }
const _hoisted_8 = {
  key: 0,
  class: "delete-confirmation__detail-item"
}
const _hoisted_9 = { class: "delete-confirmation__detail-label" }
const _hoisted_10 = { class: "delete-confirmation__detail-value" }
const _hoisted_11 = {
  key: 1,
  class: "delete-confirmation__detail-item"
}
const _hoisted_12 = { class: "delete-confirmation__detail-label" }
const _hoisted_13 = { class: "delete-confirmation__detail-value" }
const _hoisted_14 = { class: "delete-confirmation__actions" }

import AppModal from '../../base/Modal.vue';
import AppButton from '../../base/AppButton.vue';

interface Props {
  filename: string;
  docType: string;
  description: string;
  loading: boolean;
}

interface Emits {
  (e: 'confirm'): void;
  (e: 'cancel'): void;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'DeleteConfirmationModal',
  props: {
    filename: {},
    docType: { default: '' },
    description: { default: '' },
    loading: { type: Boolean, default: false }
  },
  emits: ["confirm", "cancel"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AppModal, {
    show: true,
    title: _ctx.$t('documents.confirmDelete'),
    icon: "exclamation-triangle",
    size: "medium",
    gradientHeader: true,
    loading: _ctx.loading,
    onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('cancel')))
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_14, [
        _createVNode(AppButton, {
          type: "button",
          variant: "outline",
          size: "medium",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('cancel'))),
          class: "delete-confirmation__btn delete-confirmation__btn--cancel"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('common.cancel')), 1)
          ]),
          _: 1
        }),
        _createVNode(AppButton, {
          type: "button",
          variant: "danger",
          size: "medium",
          onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.$emit('confirm')), ["stop"])),
          disabled: _ctx.loading,
          loading: _ctx.loading,
          class: "delete-confirmation__btn delete-confirmation__btn--confirm"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('documents.delete')), 1)
          ]),
          _: 1
        }, 8, ["disabled", "loading"])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _cache[3] || (_cache[3] = _createElementVNode("svg", {
            class: "delete-confirmation__warning-icon",
            viewBox: "0 0 24 24",
            width: "20",
            height: "20"
          }, [
            _createElementVNode("path", {
              fill: "currentColor",
              d: "M13 14H11V9H13M13 18H11V16H13M1 21H23L12 2L1 21Z"
            })
          ], -1)),
          _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t('documents.deleteWarning', { filename: _ctx.filename })), 1)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('documents.filename')) + ":", 1),
            _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.filename), 1)
          ]),
          (_ctx.docType)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t('documents.documentType')) + ":", 1),
                _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t(`${_ctx.docType}`)), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.description)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t('documents.description')) + ":", 1),
                _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.description), 1)
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _: 1
  }, 8, ["title", "loading"]))
}
}

})